<div class="pageheader">
  <div class="page-title">
    <h1>Monitor status</h1>
    <div class="btn-group" data-toggle="buttons">
      <button class="btn btn-link" id="btnFullscreen" (click)="goFullScreen()">Go Fullscreen <ep-svg-icon icon="eye"></ep-svg-icon></button>
    </div>
  </div>
</div>

<div>
  <label class="pull-right">@if (isUpdating) {
    <img src="../../images/ajax-loader.gif" alt="Updating..." />
  } Last updated: {{dateTimeService.getFormattedTime(lastUpdate)}}</label>
</div>

<div>
  <br />
</div>

<div #fullscreen [class.fullscreen]="isFullScreen">
  <app-monitor-display [monitorLayout]="monitorLayout" [(isDragging)]="isDragging" (triggerRefresh)="onTriggerRefresh($event)"></app-monitor-display>
</div>

